import React from 'react'
import { fade, makeStyles } from '@material-ui/core/styles'
import {getPlan} from "utils/auth";
import cautionImage from './images/caution.png'
import { A } from "components/ImgIcon"
import {
    Grid,
    Dialog,
    DialogContent,
    DialogTitle,
    Card,
    CardActionArea,
    CardContent,
    Typography,
    CardActions,
    Button,
    Slide,
    IconButton,
    LinearProgress,
    Divider,
    Box
} from "@material-ui/core";
import {getPlansForUpgrade} from "../utils/auth";
import {CloseRounded as CloseIcon} from "@material-ui/icons"
import {
    currentOrganization,
    getOrganizationUserLicenses,
    getOrganizationUsers
} from "redux/selectors";

import connect from "react-redux/es/connect/connect";
import {contactSales, upgradeLicensing} from "../rest/API";
import swal from "sweetalert";
import {Utils} from "revlock-webutils";
import GA from 'utils/GoogleAnalytics'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    media: {
        height: 100,
        objectFit: 'contain'
    },
    title:{
        color: '#6200ea',
        fontSize:'20px',
    },
    mainheading:{
        color: '#6200ea',
        fontSize:'25px',
    },
    selected: {
        border: `2px solid ${fade(theme.palette.primary.main, .4)}`,
    },
    dialogTitle: {
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        justify: 'flex-start'
    },
    actionsRoot: {
        justifyContent: 'flex-end'
    }
}));


function PlanSplash(props) {
    const {handleInquiry, handleUpgrade, plans, currentPlan, nextPlan} = props;
    const classes = useStyles();

    const splashOtherMessage = React.useMemo(()=>{
        if(currentPlan.name === 'rev-essential'){
            return <Typography>
                Learn more about all the great <A href={'https://www.chargebee.com/docs/revrec/revrec-reporting.html'}>accounting and control features</A> available when you upgrade.
            </Typography>

        }

        return null;
    }, [currentPlan])
    const toPeriod = (plan) => {
        switch (plan.term) {
            case "monthly":
                return "/mo";
            case "annual":
                return "/yr";
            default:
                return ""
        }
        return ""
    }

    const planLink = () => {
        Utils.showPopup({ url: 'https://calendly.com/ckirsch' })
    }

    const upgradeToPlan = nextPlan ? nextPlan.name : 'rev-up';
    const upgradePlan = plans.find((p) => p.name === upgradeToPlan);

    return (
        <Grid container spacing={0} justify={'center'} alignItems={'center'}>
            <Grid item xs={12}>
                <Card className={classes.root}>
                    <CardActionArea>
						{!currentPlan.isTrial &&
							<>
                  <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                  }}>
                      <img className={classes.media} src={cautionImage}/>
                      <div style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          flexDirection: 'column',
                          padding: 16,
                      }}>
                          <Typography variant="body1"
                                      color={'textSecondary'}>
                              You do not have access to this feature as a part
                              of your current plan: <b>{currentPlan.label}</b>.
                              <br/>
                          </Typography>
                          {splashOtherMessage}
                      </div>
                  </div>
						</>
						}
						{currentPlan.isTrial && <>
							<div style={{
								display: 'flex',
								justifyContent: 'space-between',
							}} onClick={() => planLink(upgradePlan)}>
								<img className={classes.media}
								     src={upgradePlan.image}/>
								<Box display={'flex'} flexDirection={'column'}
								     justifyContent={'space-around'}
								     alignItems={'center'} padding={2}>
									<div style={{
										display: 'flex',
										justifyContent: 'flex-start',
									}}>
										<Typography nowrap color={'primary'}
										            variant={'h2'}>{upgradePlan.price}</Typography>
										<Typography nowrap
										            style={{ leftPadding: 8 }}
										            variant={'body1'}>{toPeriod(upgradePlan)}</Typography>
									</div>
								</Box>
							</div>
							<CardContent>
								<Typography className={classes.title}
								            gutterBottom variant="h5"
								            component="h2">
									{upgradePlan.label}
								</Typography>
								<Typography variant="body2"
								            color="textSecondary" component="p"
								            style={{ height: 40 }}>
									{upgradePlan.longDescription}
								</Typography>
							</CardContent>
						</>}
                    </CardActionArea>
                    <CardActions classes={{root: classes.actionsRoot}}>
						<Button size="medium" variant="contained"
                                color="primary"
                                onClick={(e) => handleInquiry(upgradePlan, e)}>
                            Contact Sales
                        </Button>
						<Button size="medium" variant="contained"
                                color="primary"
                                onClick={(e) => handleUpgrade(upgradePlan, e)}>
                            Try Free for 30 days
                        </Button>
                    </CardActions>
                </Card>
            </Grid>
			{currentPlan.isTrial &&
			<Grid item xs={12}>
				<Typography variant={"caption"} color={'primary'}><sup>*</sup>Note that subscriptions are processed and applied immediately.</Typography>
			</Grid>
			}
        </Grid>)


}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function UpgradeSplashDialog(props) {
	const {
		onClose,
		open,
		currentOrganization,
	} = props
	const classes = useStyles()

    if (!currentOrganization)
        return <LinearProgress/>

	const currentPlan = getPlan()

	const isTrial = currentPlan && currentPlan.isTrial;
	const plans = getPlansForUpgrade();
    const nextPlan = plans.nextPlan;

    const handleInquiry = async (option, e) => {
        e.stopPropagation();
        try {
            await contactSales(currentOrganization.id, option.type, option.name);

            onClose && onClose();

            await swal({
                title: `Feature Access`,
                icon: 'success',
                text: `Our sales team have been notified of your inquiry ` +
                    `regarding upgrading your current license and ` +
                    `will get back to you soon.`,
                buttons: true
            });
        } catch (err) {
            await swal({
                title: 'Error',
                icon: 'error',
                text: `Something didn't quite work ${err.errorMessage}`,
                error: true,
                timer: 2000,
                buttons: false
            });
        }
    }

    const handleUpgrade = async (option, e) => {
        e.stopPropagation();

        const {invalidateLicense} = props;

        try {
            await upgradeLicensing(currentOrganization.id, option.type, option.name, true);

            await GA.setEvent({
                category: "Upgrade",
                action: `License - ${nextPlan && nextPlan.name}`, value: 1});

            invalidateLicense();
            onClose && onClose();

            await swal({
                title: `Congratulations`,
                icon: 'success',
                text: `Your trial license has been activated for 30 days.`,
                buttons: true
            });
        } catch (err) {
            await swal({
                title: 'Error',
                icon: 'error',
                text: `Something didn't quite work ${err.errorMessage}`,
                error: true,
                timer: 2000,
                buttons: false
            });
        }
    };

    return (
        <Dialog onClose={onClose} open={open} TransitionComponent={Transition} maxWidth={'lg'}>
            <DialogTitle>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Typography variant={'h4'} color={'primary'}>{plans.isTrial ? "Sign-up today" : "Upgrade your subscription"}</Typography>
                    <IconButton size={30} onClick={onClose}>
                        <CloseIcon size={'small'}/>
                    </IconButton>
                </div>
            </DialogTitle>
            <Divider/>
			<DialogContent style={{
				overflowY: 'auto',
				padding: '16px 24px',
			}}>
				<PlanSplash {...props} {...plans} currentPlan={currentPlan}
                            nextPlan={nextPlan}
                            handleUpgrade={handleUpgrade}
                            handleInquiry={handleInquiry}/>
            </DialogContent>
        </Dialog>)
}


const mapStateToProps = (state) => {
    return {
        currentOrganization: currentOrganization(state),
        organizationUsers: getOrganizationUsers(state),
        organizationUserLicenses: getOrganizationUserLicenses(state),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        invalidateLicense: () => {
            dispatch({
				type: 'ORGANIZATION_INVALIDATE',
			})

            dispatch({
				type: 'ORGANIZATION_USERS_INVALIDATE',
            })

		},
        }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeSplashDialog);
